import { createRootRoute, Outlet } from "@tanstack/react-router";
import { Toaster } from "@/components/sonner";
import { NotFoundPage } from "@/routes/not-found";

export const RootRoute = createRootRoute({
  component: function RootComponent() {
    return (
      <div className="min-h-screen bg-background">
        <Outlet />
        <Toaster richColors position="top-center" />
      </div>
    );
  },
  notFoundComponent: NotFoundPage,
});
